<form [formGroup]="form" (ngSubmit)="save()">
  <div class="alert alert-warning" role="alert">
    <strong>
      {{
        'organizations.licenseEntitlements.enforcementNoticeTitle' | translate
      }}
    </strong>
    {{ 'organizations.licenseEntitlements.enforcementNotice' | translate }}
  </div>

  <div formArrayName="entitlements">
    @for (
      entitlement of entitlements.controls;
      track entitlement;
      let i = $index
    ) {
      <div class="row align-items-start mb-3" [formGroupName]="i">
        <div class="col-md-6">
          <label class="form-label">
            {{ 'organizations.licenseEntitlements.type' | translate }}
          </label>
          <p-select
            [options]="availableLicenseTypes(i)"
            formControlName="type"
            optionLabel="label"
            optionValue="value"
            class="w-100"
          />
          @if (
            entitlement.controls.type.touched &&
            entitlement.controls.type.invalid
          ) {
            <div class="text-danger small">
              {{
                'organizations.licenseEntitlements.validation.typeRequired'
                  | translate
              }}
            </div>
          }
        </div>

        <div class="col-md-4">
          <label class="form-label">
            {{ 'organizations.licenseEntitlements.purchasedCount' | translate }}
          </label>
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            formControlName="purchasedCount"
          />
          @if (
            entitlement.controls.purchasedCount.touched &&
            entitlement.controls.purchasedCount.invalid
          ) {
            <div class="text-danger small">
              {{
                'organizations.licenseEntitlements.validation.count' | translate
              }}
            </div>
          }
        </div>

        <div class="col-md-2 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-outline-danger mt-4"
            (click)="removeEntitlement(i)"
          >
            {{ 'organizations.licenseEntitlements.remove' | translate }}
          </button>
        </div>
      </div>
    }
  </div>

  @if (hasDuplicateTypes()) {
    <div class="text-danger mb-3">
      {{
        'organizations.licenseEntitlements.validation.duplicateType' | translate
      }}
    </div>
  }

  <button
    type="button"
    class="btn btn-outline-secondary me-2"
    [disabled]="entitlements.length >= licenseTypes.length || loading"
    (click)="addEntitlement()"
  >
    {{ 'organizations.licenseEntitlements.add' | translate }}
  </button>
  <button
    type="submit"
    class="btn btn-secondary"
    [disabled]="form.invalid || hasDuplicateTypes()"
    [ladda]="loading"
  >
    {{ 'save' | translate }}
  </button>

  <app-error [error]="error"></app-error>
</form>
